import { Typography } from "@hellocarbo/lasagne";
import { cn } from "@hellocarbo/lasagne/utils";
import { FC, type JSX, SVGProps } from "react";

function ChartTooltip({
  seriesName,
  valueToDisplay,
  unit,
  color,
  Icon,
  iconClassName,
  extraInfo,
}: {
  seriesName: string;
  valueToDisplay: string;
  unit: string;
  color?: string;
  Icon?: FC<SVGProps<SVGSVGElement>>;
  iconClassName?: string;
  extraInfo?: JSX.Element;
}) {
  return (
    <div className="gap-3xs border-grayscale-x-light p-2xs flex flex-col rounded-[8px] border bg-white shadow-lg">
      <div className="gap-3xs flex items-center">
        {Icon && (
          <Icon
            className={cn("mr-3xs size-2xs", iconClassName)}
            fill={color}
            role="img"
            aria-label="An icon representing the hovered data"
          />
        )}
        <Typography step="-1">{seriesName}</Typography>
        <Typography step="-1" as="span" className="ml-lg">
          {valueToDisplay}
          &nbsp;
          <Typography step="-2" as="span" className="text-grayscale">
            {unit}
          </Typography>
        </Typography>
      </div>
      {Boolean(extraInfo) && <>{extraInfo}</>}
    </div>
  );
}

export default ChartTooltip;
